export default {
  install (Vue) {
    // Definisci le tue funzioni di validazione qui
    Vue.prototype.$validateEmail = function (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }

    Vue.prototype.$validatePassword = function (password) {
      if (password === null || password === undefined) {
        return false // Il valore è nullo o indefinito, quindi non valido
      }
      if (typeof password === 'string' && password.trim() === '') {
        return false // Il valore è una stringa vuota (dopo aver rimosso gli spazi bianchi), quindi non valido
      }
      if (Array.isArray(password) && password.length === 0) {
        return false // Il valore è un array vuoto, quindi non valido (a seconda dei tuoi requisiti)
      }

      const pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&.])[A-Za-z\d@$!%?&.]{8,}$/
      return pwdRegex.test(password)
    }

    Vue.prototype.$validateRequired = function (value) {
      if (value === null || value === undefined) {
        return false // Il valore è nullo o indefinito, quindi non valido
      }
      if (typeof value === 'string' && value.trim() === '') {
        return false // Il valore è una stringa vuota (dopo aver rimosso gli spazi bianchi), quindi non valido
      }
      if (Array.isArray(value) && value.length === 0) {
        return false // Il valore è un array vuoto, quindi non valido (a seconda dei tuoi requisiti)
      }

      return true // Il valore non è vuoto
    }

    Vue.prototype.$validateSamePassword = function (p, c) {
      if (p !== c) {
        return false // Il valore è nullo o indefinito, quindi non valido
      }
      return true // Il valore non è vuoto
    }
  }
}
